const bytesToHex = (bytes: Uint8Array): string =>
  Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");

export const calculateBlobContentFingerprint = async (
  blob: Blob,
): Promise<string> => {
  const subtleCrypto = globalThis.crypto?.subtle;
  if (!subtleCrypto) {
    throw new Error("Content fingerprinting is not supported in this browser");
  }

  const digest = await subtleCrypto.digest("SHA-256", await blob.arrayBuffer());
  return `sha256:${bytesToHex(new Uint8Array(digest))}`;
};
